import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import { redirectToUsers } from '../../../utils/appointments/redirect-utils';
import AppointmentHeader from '../Components/AppointmentHeader';
import EmptyContent from '../../common/EmptyState/Content';
import Shape from '../../common/Shape';
import styles from '../styles.styl';
import { enhance } from './enhance';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';

function AppointmentOrganizations({
  intl: { formatMessage },
  setActiveOrganization,
  myProvidersInit,
  organizations,
  subtitle,
}) {
  usePageView('Get Care | Choose Organization');

  const handleSelect = organization => {
    setActiveOrganization(organization);
    myProvidersInit(organization);
  };

  function renderImage(logo) {
    return () => (
      <img
        alt="organization"
        style={{ width: 40 }}
        src={get(logo, 'thumbMin')}
      />
    );
  }

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.organization" />
      <AppointmentHeader
        title="appointments.chooseOrganization"
        subtitle={subtitle}
        handleBack={redirectToUsers}
      />
      {organizations.map(organization => (
        <Shape
          onClick={() => handleSelect(organization)}
          renderPrimary={() => organization.name}
          renderLeft={renderImage(organization.logo)}
          key={organization.id}
        />
      ))}

      {!organizations.length && (
        <EmptyContent
          className={styles.emptyBlock}
          text={formatMessage({ id: `appointments.emptyOrganizations` })}
          icon="search-list"
        />
      )}
    </Fragment>
  );
}

AppointmentOrganizations.propTypes = {
  setActiveOrganization: PropTypes.func,
  myProvidersInit: PropTypes.func,
  organizations: PropTypes.array,
  subtitle: PropTypes.object,
  intl: PropTypes.object,
};

export default enhance(AppointmentOrganizations);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentOrganizations/index.jsx